module.exports = __webpack_public_path__ + "img/title.3830bdd6.png";